import { 
  checkCollisionWithWindZones, 
  checkCollisionWithVirtualWindZones,
} from '__editor/panelsEditor/components/roofZones/utils/windZonesCollisionsDetection';
import { ASCE_716_ROOF_ZONES } from '__editor/panelsEditor/components/roofZones/roofZoneNumbers';
import { shouldUseVirtualRoofEdges } from '__editor/panelsEditor/panelsEditorHelper';
import { getBuildingHeight } from 'projectDesign/components/projectConfiguration/projectConfiguration';

export const getZoneInformation = (
  state: appState, 
  roofId: number, 
  panel: panelInState,
): { zone: roofZoneNumber, edgeType?: number } => {
  if (!state) {
    console.error('getZoneInformation called with undefined state');
    return { zone: ASCE_716_ROOF_ZONES.MIDDLE };
  }

  const background = state.background || {} as appState['background'];
  const projectConfiguration = state.projectConfiguration || {} as appState['projectConfiguration'];
  const tiltedRoof = state.tiltedRoof || {} as appState['tiltedRoof'];
  const settings = state.settings || {} as appState['settings'];
  const roofsSelector = state.roofsSelector || {} as appState['roofsSelector'];
  const drawingManager = state.drawingManager || {} as appState['drawingManager'];
  const projectEnvConfig = projectConfiguration.projectEnvConfig || {} as any;
  const defaultZone = panel.roofZone || ASCE_716_ROOF_ZONES.MIDDLE;
  const panelEditorActive = !!background.panelEditorActive;
  const mapType = roofsSelector.mapType;
  const productId = projectConfiguration.productId;
  const projectVersion = projectConfiguration.projectVersion;
  const roofPitch = tiltedRoof.roofPitch;
  const panelHeight = settings.panelHeight;
  const panelWidth = settings.panelWidth;
  const buildingType = projectEnvConfig.building_type;
  const roofs = drawingManager.roofs;

  let metersPerPixel: number;
  let roofCenter: cordPoint;
  let bgRotationDegrees: number;
  let zoom: number;
  let bgOffset: pixelPoint;
  let roofEdges: cordPoint[];
  const buildingHeightFt = Number(getBuildingHeight()) || 0;

  if (panelEditorActive) {
    metersPerPixel = background.metersPerPixel;
    roofCenter = background.cords;
    bgRotationDegrees = background.rotationDegrees;
    zoom = background.zoom;
    bgOffset = background.bgXY;
    roofEdges = background.roofEdges;
  } else {
    const roof = roofs && roofs[roofId];

    if (!roof) {
      return { zone: defaultZone };
    }

    metersPerPixel = roof.metersPerPixel;
    roofCenter = roof.marker;
    bgRotationDegrees = roof.bgRotation;
    zoom = roof.zoom;
    bgOffset = roof.bgOffset;
    roofEdges = roof.coords;
  }

  if (!bgOffset || !Number.isFinite(metersPerPixel)) {
    return { zone: defaultZone };
  }

  if (shouldUseVirtualRoofEdges(mapType, productId, projectVersion)) {
    return checkCollisionWithVirtualWindZones({
      panel,
      relativeToCenter :true, 
      metersPerPixel, 
      bgXOffset: bgOffset.x, 
      bgYOffset: bgOffset.y, 
      insideOfPolygon: true,
    });
  }

  if (!roofCenter || !roofEdges || !roofEdges.length || !Number.isFinite(zoom)) {
    return { zone: defaultZone };
  }

  return checkCollisionWithWindZones({
    panel,
    relativeToCenter :true, 
    roofEdges, 
    roofCenter, 
    zoom, 
    buildingHeightFt, 
    metersPerPixel, 
    bgRotationDegrees,
    bgXOffset: bgOffset.x, 
    bgYOffset: bgOffset.y, 
    panelWidth, 
    panelHeight,
    insideOfPolygon: true,
    buildingType,
    roofPitch,
    roofId,
  });
};
